import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GroupInput } from '../../../../components/GroupInput/GroupInput';
import { START_TO_TYPE } from '../consts';
import { getServiceFilter, getServiceSelected } from '../../../store/selectors';
import { selectBranch, setBookingError, setPreselectedData } from '../../../store/serviceSlice';

export const BranchSelector = ({ onSelect }) => {
    const { branches: selected = '' } = useSelector(getServiceSelected);
    const { branches: data = [] } = useSelector(getServiceFilter);
    const dispatch = useDispatch();

    const getMetadata = useCallback(() => {
        return data.map((item) => {
            const id = (item?.id ? item.id : item?.name);
            const code = (item?.code ? item?.code : item?.name);
            return {
                ...item,
                id,
                code,
            };
        });
    }, [data]);

    const onChangeHandler = (value) => {
        dispatch(setBookingError(''));
        dispatch(setPreselectedData({
            branches: null,
            doctors: null,
        }));
        if (onSelect) {
            if (onSelect(value)) {
                dispatch(selectBranch(value));
            }
        } else {
            dispatch(selectBranch(value));
        }
    };
    return <>
        <GroupInput
            type="selector"
            label="Филиал"
            placeholder={START_TO_TYPE}
            value={selected}
            onChange={onChangeHandler}
            metaData={getMetadata()}
            onClear={() => onChangeHandler('')}
            id="branch"
        />
    </>;
};
